export const PROFILE_EDIT_VIEW_LS_KEY = "profileEditView";

export const PROFILE_ENDPOINT = "/profile";
